export const afyaTheme = {
  headline1: {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '24px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  headline2: {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '20px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  headline3: {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '16px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  headline4: {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '14px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  body: {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '14px',
    lineHeight: '200%',
    fontWeight: 400,
  },
  'body(semi bold)': {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '14px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  'body(bold)': {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '14px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  small: {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '12px',
    lineHeight: '200%',
    fontWeight: 400,
  },
  'small(semi bold)': {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '12px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  'small(bold)': {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '12px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  tiny: {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '11px',
    lineHeight: '200%',
    fontWeight: 400,
  },
  'tiny(semi bold)': {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '11px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  'tiny(bold)': {
    fontFamily: "'AfyaSans', 'Arial', 'sans-serif'",
    fontSize: '11px',
    lineHeight: '200%',
    fontWeight: 700,
  },
  type: {
    body: '#485668',
    link: '#212322',
    'link-cms': '#3077dd',
    'link-hover': '#CE0058',
    button: '#FFFFFF',
    'button-hover': '#FFFFFF',
    'button-active': '#FFFFFF',
    'button-light': '#212322',
    'button-light-active': '#FFFFFF',
    'button-disabled': '#979CA1',
    menu: '#212322',
    'active-menu': '#CE0058',
    'input-focus': '#5C5F61',
    body_dark: '#FFFFFF',
    placeholder: '#979CA1',
    icon: '#CE0058',
  },
  surface: {
    button: '#212322',
    'button-hover': '#CE0058',
    'button-active': '#CE0058',
    'button-light': '#FFFFFF',
    'button-light-hover': '#FFFFFF',
    'button-light-active': '#FFFFFF',
    'button-disabled': '#E5E6EA',
    body: '#F3F7F9',
    header: '#FFFFFF',
    box: '#FFFFFF',
    'box-dark': '#1C1B1F',
    highlight: '#FBE6EF',
    overlay: '#666',
    image: '#E5E6EA',
    'menu-active': '#FBE6EF',
    'menu-hover': '#E5E6EA',
    input: '#FFFFFF',
    'input-disabled': '#E5E6EA',
    tag: '#FFFFFF',
  },
  feedback: {
    success: '#2DAC3A',
    'surface-success': '#DFF3E1',
    alert: '#F7B500',
    'surface-alert': '#FEF4D9',
    error: '#DA3333',
    'surface-error': '#F9E0E0',
  },
  border: {
    box: '#E5E6EA',
    button: '#212322',
    'alternative-button': '#D4DBDF',
    'button-light': '#E5E6EA',
    'button-light-hover': '#212322',
    'button-light-active': '#212322',
    'button-disabled': '#979CA1',
    'active-menu': '#CE0058',
    input: '#E5E6EA',
    'input-focus': '#5C5F61',
    'input-disabled': '#E5E6EA',
    tag: '#D4DBDF',
    width: {
      'selected-pdf': '4px',
      box: '1px',
      'input-search': '1px',
      button: '1px',
      input: '1px',
      'active-menu': '2px',
      loading: '4px',
    },
    radius: {
      box: '8px',
      'input-search': '99999px',
      'open-search': '20px',
      tag: '99999px',
      button: '4px',
      input: '4px',
      menu: '4px',
      modal: '8px',
    },
  },
  spacing: {
    positive: {
      none: 0,
      '2xp': '4px',
      xp: '8px',
      p: '12px',
      m: '16px',
      l: '20px',
      xl: '24px',
      '2xl': '32px',
      '3xl': '40px',
      '4xl': '48px',
      '5xl': '56px',
    },
  },
  shadow: { box: '0px 4px 6px 0px rgba(0, 0, 0, 0.10)' },
};

export default afyaTheme;
